export default class GeoblockChecker {
  static checkContent(geoblockUrl) {
    return new Promise((resolve) => {
      let client = new XMLHttpRequest();
      client.onload = () => {
        const blocked = this.responseIsBlocked(client);
        resolve(blocked);
      };
      client.open("GET", geoblockUrl);
      client.send(null);
    });
  }

  static responseIsBlocked(client){
    let responseHeader, blocked;
    if(client.getAllResponseHeaders().toLowerCase().search("x-region-blocked") >= 0){
      responseHeader = client.getResponseHeader("X-Region-Blocked");
    }
    let responseStatus = client.status;
    blocked = (responseStatus == 403) && (responseHeader == "true");
    return blocked;
  }
}
